var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visibility-changer" },
    [
      !!_vm.user.role.isRoot
        ? _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "section-header" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v("Temsil Edilen Mailler"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "switch-container" },
                [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Diğer temsilcilere ait mailleri görüntüle"),
                  ]),
                  _vm._v(" "),
                  _c("a-switch", {
                    attrs: { size: "small" },
                    on: { change: _vm.changeIsAgentMailVisible },
                    model: {
                      value: _vm.isAgentMailVisible,
                      callback: function ($$v) {
                        _vm.isAgentMailVisible = $$v
                      },
                      expression: "isAgentMailVisible",
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "section" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "section-content mail-selector" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedMailId,
                  expression: "selectedMailId",
                },
              ],
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedMailId = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.mailAddresses, function (mail) {
              return _c(
                "option",
                { key: mail._id, domProps: { value: mail._id } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(mail.mail) +
                      "\n                "
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "visibility-options" }, [
          _c(
            "div",
            {
              staticClass: "option",
              class: { selected: _vm.visibilityType === "public" },
              on: {
                click: function ($event) {
                  _vm.visibilityType = "public"
                  _vm.handleVisibilityTypeChange()
                },
              },
            },
            [
              _c("div", { staticClass: "option-header" }, [
                _c("div", { staticClass: "radio" }, [
                  _vm.visibilityType === "public"
                    ? _c("div", { staticClass: "inner" })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-title" }, [
                  _vm._v("Herkese Açık"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "option-content" }, [
                _vm._v("Bu mail tüm temsilciler tarafından görüntülenebilir."),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "option",
              class: { selected: _vm.visibilityType === "restricted" },
              on: {
                click: function ($event) {
                  _vm.visibilityType = "restricted"
                  _vm.handleVisibilityTypeChange()
                },
              },
            },
            [
              _c("div", { staticClass: "option-header" }, [
                _c("div", { staticClass: "radio" }, [
                  _vm.visibilityType === "restricted"
                    ? _c("div", { staticClass: "inner" })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-title" }, [
                  _vm._v("Kısıtlı Erişim"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "option-content" }, [
                _vm._v(
                  "\n                    Bu maili sadece seçtiğiniz temsilciler veya departmanlar görüntüleyebilir.\n                "
                ),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.visibilityType === "restricted"
        ? [
            _c("div", { staticClass: "items-panel" }, [
              _c("div", { staticClass: "panel-header" }, [
                _c("div", { staticClass: "panel-title" }, [
                  _vm._v("Görüntüleyebilen Temsilciler"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "custom-add-button",
                    on: { click: _vm.openAgentModal },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [_vm._v("+")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [_vm._v("Ekle")]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-content" }, [
                _vm.cloneUserIds.length === 0
                  ? _c("div", { staticClass: "empty-state" }, [
                      _vm._v("Henüz temsilci seçilmedi"),
                    ])
                  : _c(
                      "div",
                      { staticClass: "items-grid" },
                      _vm._l(_vm.cloneUserIds, function (id) {
                        return _c(
                          "div",
                          { key: id, staticClass: "item-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "avatar-container" },
                              [
                                _c("Avatar", {
                                  staticClass: "avatar",
                                  attrs: {
                                    size: 36,
                                    src: _vm.getUser(id).gravatar,
                                    username: _vm.getUser(id).name,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-details" }, [
                              _c("div", { staticClass: "item-name" }, [
                                _vm._v(_vm._s(_vm.getUser(id).name)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item-actions" },
                              [
                                _c("SupsisButton", {
                                  staticClass: "delete-btn",
                                  attrs: { icon: "close", xxsmall: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteAgent(id)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "items-panel" }, [
              _c("div", { staticClass: "panel-header" }, [
                _c("div", { staticClass: "panel-title" }, [
                  _vm._v("Görüntüleyebilen Departmanlar"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "custom-add-button",
                    on: { click: _vm.openDepartmentModal },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [_vm._v("+")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [_vm._v("Ekle")]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-content" }, [
                _vm.cloneDepartmentIds.length === 0
                  ? _c("div", { staticClass: "empty-state" }, [
                      _vm._v("Henüz departman seçilmedi"),
                    ])
                  : _c(
                      "div",
                      { staticClass: "items-grid" },
                      _vm._l(_vm.cloneDepartmentIds, function (id) {
                        return _c(
                          "div",
                          { key: id, staticClass: "item-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "avatar-container" },
                              [
                                _c("Avatar", {
                                  staticClass: "avatar",
                                  attrs: {
                                    size: 36,
                                    src: undefined,
                                    username: _vm.getDepartmentTitle(
                                      _vm.getDepartment(id)
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-details" }, [
                              _c("div", { staticClass: "item-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDepartmentTitle(
                                      _vm.getDepartment(id)
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item-actions" },
                              [
                                _c("SupsisButton", {
                                  staticClass: "delete-btn",
                                  attrs: { icon: "close", xxsmall: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteDepartment(id)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.visibleAgentModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Temsilci Seç",
                description: "Görüntüleyebilecek temsilcileri seçin",
                okText: "Kaydet",
                cancelText: "İptal",
                className: _vm.agentModalClass,
                showTitle: false,
                showFooter: false,
              },
              on: { cancel: _vm.cancelAgentModal, ok: _vm.confirmAgentModal },
            },
            [
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "header-title" }, [
                    _vm._v("Temsilci Seç"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-description" }, [
                    _vm._v("Görüntüleyebilecek temsilcileri seçin"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-search" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchText,
                        expression: "searchText",
                      },
                    ],
                    attrs: { placeholder: "Temsilci Ara" },
                    domProps: { value: _vm.searchText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchText = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "material-icons search-icon" }, [
                    _vm._v("search"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "select-all-option" },
                  [
                    _c(
                      "a-checkbox",
                      {
                        attrs: { checked: _vm.tempSelectAllAgents },
                        on: {
                          change: function ($event) {
                            return _vm.toggleTempSelectAllAgents()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Tüm Temsilcileri Seç\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "items-list" },
                  _vm._l(_vm.getFilteredUsers(), function (agent) {
                    return _c(
                      "div",
                      {
                        key: agent._id,
                        staticClass: "item",
                        on: {
                          click: function ($event) {
                            return _vm.toggleTempAgent(agent._id)
                          },
                        },
                      },
                      [
                        _c("a-checkbox", {
                          staticClass: "checkbox",
                          attrs: {
                            checked: _vm.tempUserIds.includes(agent._id),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-content" }, [
                          _c(
                            "div",
                            { staticClass: "user-info" },
                            [
                              _c("Avatar", {
                                attrs: {
                                  size: 32,
                                  src: agent.gravatar,
                                  username: agent.name,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "user-details" }, [
                                _c("div", { staticClass: "name" }, [
                                  _vm._v(_vm._s(agent.name)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "description" }, [
                                  _vm._v(
                                    _vm._s(_vm.getAgentDepartmentNames(agent))
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "status",
                              class: agent.status.toLowerCase(),
                            },
                            [
                              _c("div", { staticClass: "status-indicator" }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(agent.status) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { staticClass: "button-group" }, [
                    _c(
                      "div",
                      {
                        staticClass: "custom-button cancel",
                        on: { click: _vm.cancelAgentModal },
                      },
                      [_vm._v("İptal")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "custom-button primary",
                        on: { click: _vm.confirmAgentModal },
                      },
                      [_vm._v("Kaydet")]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.visibleDepartmentModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Departman Seç",
                description: "Görüntüleyebilecek departmanları seçin",
                okText: "Kaydet",
                cancelText: "İptal",
                className: _vm.departmentModalClass,
                showTitle: false,
                showFooter: false,
              },
              on: {
                cancel: _vm.cancelDepartmentModal,
                ok: _vm.confirmDepartmentModal,
              },
            },
            [
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "header-title" }, [
                    _vm._v("Departman Seç"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-description" }, [
                    _vm._v("Görüntüleyebilecek departmanları seçin"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-search" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchText,
                        expression: "searchText",
                      },
                    ],
                    attrs: { placeholder: "Departman Ara" },
                    domProps: { value: _vm.searchText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchText = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "material-icons search-icon" }, [
                    _vm._v("search"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "select-all-option" },
                  [
                    _c(
                      "a-checkbox",
                      {
                        attrs: { checked: _vm.tempSelectAllDepartments },
                        on: {
                          change: function ($event) {
                            return _vm.toggleTempSelectAllDepartments()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Tüm Departmanları Seç\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "items-list" },
                  _vm._l(_vm.getFilteredDepartments(), function (department) {
                    return _c(
                      "div",
                      {
                        key: department._id,
                        staticClass: "item",
                        on: {
                          click: function ($event) {
                            return _vm.toggleTempDepartment(department._id)
                          },
                        },
                      },
                      [
                        _c("a-checkbox", {
                          staticClass: "checkbox",
                          attrs: {
                            checked: _vm.tempDepartmentIds.includes(
                              department._id
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-content" }, [
                          _c(
                            "div",
                            { staticClass: "user-info" },
                            [
                              _c("Avatar", {
                                attrs: {
                                  size: 32,
                                  src: undefined,
                                  username: _vm.getDepartmentTitle(department),
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "user-details" }, [
                                _c("div", { staticClass: "name" }, [
                                  _vm._v(
                                    _vm._s(_vm.getDepartmentTitle(department))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "description" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.getDepartmentUsers(department._id)
                                          .length
                                      ) +
                                      " Temsilci\n                                "
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "avatar-group" },
                            [
                              _vm._l(
                                _vm.getDepartmentUsers(department._id, 2),
                                function (user) {
                                  return _c("Avatar", {
                                    key: user._id,
                                    staticClass: "avatar-wrapper",
                                    attrs: {
                                      size: 24,
                                      src: user.gravatar,
                                      username: user.name,
                                    },
                                  })
                                }
                              ),
                              _vm._v(" "),
                              _vm.getDepartmentUsers(department._id).length > 2
                                ? _c(
                                    "div",
                                    { staticClass: "extra avatar-wrapper" },
                                    [
                                      _vm._v(
                                        "\n                                +" +
                                          _vm._s(
                                            _vm.getDepartmentUsers(
                                              department._id,
                                              2
                                            ).length - 2
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { staticClass: "button-group" }, [
                    _c(
                      "div",
                      {
                        staticClass: "custom-button cancel",
                        on: { click: _vm.cancelDepartmentModal },
                      },
                      [_vm._v("İptal")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "custom-button primary",
                        on: { click: _vm.confirmDepartmentModal },
                      },
                      [_vm._v("Kaydet")]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Mail Adresi Seçimi")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Görünürlük Ayarları")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }